import React from "react";
import Socials from "./Socials";

const Footer = () => {
  return (
    <footer>
      <div>2023 &copy; Fatima Zohra ABID</div>
      <Socials />
    </footer>
  );
};

export default Footer;
